import { getListingImageUrl as firstUsableImageUrl } from '../AttributePanel/utils/listingImage';

/**
 * getListingImageUrl
 *
 * Returns a proxied image URL for a listing thumbnail. Handles empty values
 * and URLs containing 'nophoto' by falling back to a placeholder image.
 *
 * Takes whatever the row carries, not just a decoded array: a row that came
 * from the id resolver still holds `image_data` in the CFC's own shape, which
 * is why replacing an already-set listing showed placeholders for every row
 * while a first-time pick — mapped by the picker — showed real images.
 *
 * @param imageData - The listing's image_data (array, JSON string, or object)
 * @returns A wsrv.nl proxied image URL, or a placeholder fallback URL
 */
export function getListingImageUrl(imageData?: unknown): string {
  const fallbackUrl = encodeURIComponent('https://placehold.co/100x100/e1e1e1/666666?text=No+Image');
  const defaultImage = `https://wsrv.nl/?url=${fallbackUrl}`;

  const originalUrl = firstUsableImageUrl(imageData);
  if (!originalUrl) return defaultImage;

  return `https://wsrv.nl/?url=${encodeURIComponent(originalUrl)}&default=${fallbackUrl}`;
}
